<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>报表</el-breadcrumb-item>
      <el-breadcrumb-item>采购明细表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="关键词">
            <el-input
              size="small"
              v-model="filter.query"
              autocomplete="off"
              placeholder="编码、规格、型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="材料分类">
            <CommodityCategorySelect
              v-model="filter.category"
            ></CommodityCategorySelect>
          </el-form-item>
          <el-form-item label="供货单位">
            <CommodityParamsSelect
              v-model="filter.supplier"
              paramName="supplier"
              table="purchase_orders"
            ></CommodityParamsSelect>
          </el-form-item>
          <el-form-item label="入库日期" prop="date">
            <el-date-picker
              clearable
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData(false)
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel">
      <file-button
        obj="purchase_order_item"
        :importButton="false"
        :filter="filter"
        style="float: right"
      ></file-button>
      <mytable :list="list"></mytable>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import mytable from './table.vue'
import { purchaseOrderItemList } from '../../../service/getData'
import CommodityParamsSelect from '../orders/CommodityParamsSelect.vue'
import CommodityCategorySelect from '../../../components/select/commodity_category.vue'
export default {
  components: {
    mytable,
    CommodityParamsSelect,
    CommodityCategorySelect,
  },
  data() {
    return {
      filter: {
        page: 1,
        size: 10,
        query: '',
        supplier: '',
        category: '',
        date: '',
      },
      total: 0,
      list: [],
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.query = ''
        this.filter.supplier = ''
        this.filter.category = ''
        this.filter.date = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1

      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      let res = await purchaseOrderItemList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.count
      }
    },
  },
}
</script>